import React from "react";
import { Box } from "@mui/material";
import Nav from "./Navbar";
import Sidebar from "./Sidebar";

const AppShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%" }}>
      <Nav />
      <Box sx={{ display: "flex", flex: 1, minHeight: 0 }}>
        <Sidebar />
        <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default AppShell;


